const artificialTurf = [
  {
    question: "What is artificial turf made of?",
    answer:
      "Artificial turf<IN_CITY_ZIP> is typically made from polyethylene or polypropylene fibers that mimic the look and feel of real grass. It’s backed with a drainage layer and often infilled with sand or rubber granules for durability and comfort.",
  },
  {
    question: "How long does artificial turf last?",
    answer:
      "With proper installation and minimal upkeep, high-quality artificial turf<IN_CITY_ZIP> can last 15 to 20 years. It's UV-resistant and built to withstand heavy foot traffic and weather without fading or breaking down.",
  },
  {
    question: "Is artificial turf safe for children and pets?",
    answer:
      "Yes. Our turf products<IN_CITY_ZIP> are non-toxic, lead-free, and safe for both kids and pets. Many homeowners choose artificial grass for playgrounds and dog runs because it's soft, clean, and allergen-free.",
  },
  {
    question: "Does artificial turf require maintenance?",
    answer:
      "Artificial turf<IN_CITY_ZIP> is low-maintenance, but not maintenance-free. We recommend brushing to keep fibers upright, clearing debris, and rinsing periodically to prevent odor and dust buildup.",
  },
  {
    question: "How is the ground prepared for artificial turf?",
    answer:
      "We remove existing grass or soil<IN_CITY_ZIP>, install a weed barrier, grade the surface for drainage, and lay a compacted crushed rock base. This ensures a smooth, stable foundation before placing the turf.",
  },
  {
    question: "Will artificial turf get hot in the sun?",
    answer:
      "Yes, synthetic turf can get warmer than natural grass under direct sunlight<IN_CITY_ZIP>, especially in peak summer. We offer heat-reducing infill options and lighter-colored turf to reduce surface temperatures.",
  },
  {
    question: "Are there rebates or incentives for installing turf?",
    answer:
      "Yes. Some cities and water districts<IN_CITY_ZIP> offer turf replacement rebates as part of water conservation programs. We help check your eligibility and assist with the rebate application process.",
  },
  {
    question: "How much does artificial turf installation cost?",
    answer:
      "Pricing<IN_CITY_ZIP> varies based on square footage, site conditions, and turf quality. Most projects range from $10 to $15 per square foot. We provide custom, no-obligation estimates during your consultation.",
  },
  {
    question: "How well does artificial turf drain?",
    answer:
      "Our turf systems<IN_CITY_ZIP> include perforated backing and a crushed rock base that allows water to drain efficiently. Most installations drain better than natural grass, even during heavy rain.",
  },
  {
    question: "Is artificial turf better than real grass?",
    answer:
      "Artificial turf<IN_CITY_ZIP> eliminates mowing, watering, and mud. While real grass offers a natural feel, turf saves time, water, and money — making it ideal for drought-prone areas and busy homeowners.",
  },
];

export default artificialTurf;
